import * as React from "react";

import {
	createNativeStackNavigator,
	NativeStackScreenProps,
} from "@react-navigation/native-stack";
import LoginScreen from "./LoginScreen";
import ForgotPasswordScreen from "./ForgotPasswordScreen";
import RecreatePasswordScreen from "./RecreatePasswordScreen";
import AuthStackHeader from "./AuthStackHeader";
import ChooseSubUser from "./ChooseSubUser";
import { HomeStackNavParamList } from "../../HomeStack/HomeStack";
import { BoardingStackNavParamList } from "../BoardingStack";
import CreateCard from "./CreateCard";

type AuthStackNavParamList = {
	Login: undefined;
	ForgotPassword: undefined;
	RecreatePassword: { email: string; otp: string };
	ChooseSubUser: undefined;
	CreateCard: undefined;
	AddCard: undefined;
	AuthStack: { screen: string };
	Home: undefined;
	NewUserStack: { screen: string };
};

export type LoginScreenProps = NativeStackScreenProps<
	AuthStackNavParamList,
	"Login"
>;

export type RecreatePasswordScreenProps = NativeStackScreenProps<
	AuthStackNavParamList,
	"RecreatePassword"
>;

export type ForgotPasswordScreenProps = NativeStackScreenProps<
	AuthStackNavParamList,
	"ForgotPassword"
>;

export type ChooseSubUserScreenProps = NativeStackScreenProps<
	AuthStackNavParamList,
	"ChooseSubUser"
>;

export type CreateCardScreenProps = NativeStackScreenProps<
	AuthStackNavParamList,
	"CreateCard"
>;

const AuthStackNav = createNativeStackNavigator<AuthStackNavParamList>();

const AuthStack = () => {
	return (
		<AuthStackNav.Navigator
			initialRouteName="Login"
			screenOptions={{ header: () => <AuthStackHeader /> }}
		>
			<AuthStackNav.Screen name="Login" component={LoginScreen} />
			<AuthStackNav.Screen
				name="ForgotPassword"
				component={ForgotPasswordScreen}
			/>
			<AuthStackNav.Screen
				name="RecreatePassword"
				component={RecreatePasswordScreen}
			/>
			<AuthStackNav.Screen name="ChooseSubUser" component={ChooseSubUser} />
			<AuthStackNav.Screen name="CreateCard" component={CreateCard} />
		</AuthStackNav.Navigator>
	);
};

export default AuthStack;
